module.exports = __webpack_public_path__ + "static/media/Download.d9d474b2.svg";